import { Verified as PoaVerified } from './verified';

export default PoaVerified;
